// extracted by mini-css-extract-plugin
module.exports = {"tableWrapper":"styles_tableWrapper__1koK8","col":"styles_col__1rS_J","fulfillmentStatus":"styles_fulfillmentStatus__EHMyx","emailCol":"styles_emailCol__l9eQN"};